"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWrappedHotelLines = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const isSummaryItem_1 = require("./isSummaryItem");
const getWrappedHotelLines = (date, items) => {
    const hotel_lines = items.filter((item) => {
        if (item.type !== "HOTEL")
            return false;
        if ((0, isSummaryItem_1.isSummaryItem)(item))
            return false;
        if (!item.versions)
            return false;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
        if (!latest_version)
            return false;
        const hotel_config = latest_version.config;
        const check_in_date = dayjs(hotel_config.where_when_who.check_in_date);
        const check_out_date = check_in_date.add(hotel_config.where_when_who.number_of_nights, "day");
        const line_date = dayjs(date);
        return (line_date.isSameOrAfter(check_in_date) &&
            line_date.isSameOrBefore(check_out_date));
    });
    return hotel_lines;
};
exports.getWrappedHotelLines = getWrappedHotelLines;
